import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=e289de0c&scoped=true&lang=pug"
import script from "./CollectionCard.vue?vue&type=script&lang=js"
export * from "./CollectionCard.vue?vue&type=script&lang=js"
import style0 from "./CollectionCard.vue?vue&type=style&index=0&id=e289de0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e289de0c",
  null
  
)

export default component.exports